import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { TodoListResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTodoListsReturn {
  lists: TodoListResponse[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useTodoLists(): UseTodoListsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.todoLists.my(),
    queryFn: () => api.getMyTodoLists(),
  });

  return {
    lists: data?.lists ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load todo lists' : null,
    refresh: () => {
      refetch();
    },
  };
}
